/** PC 本机开关：允许电表写负剩余。默认关，仅影响本浏览器。 */
const ALLOW_NEGATIVE_REMAIN_KEY = 'admin_meter_allow_negative_remain';

export function isAdminMeterAllowNegativeRemain() {
  return localStorage.getItem(ALLOW_NEGATIVE_REMAIN_KEY) === '1';
}

export function setAdminMeterAllowNegativeRemain(on) {
  localStorage.setItem(ALLOW_NEGATIVE_REMAIN_KEY, on ? '1' : '0');
}
